import React from 'react'
import { List } from '../List'
import { AddAgentForm } from '../AddAgentForm'
import { UpdateAgentForm } from '../UpdateAgentForm'

export const Container = () => {
  const [component, setComponent] = React.useState('list')
  const [currentAgent, setCurrentAgent] = React.useState(null)

  return (
    <React.Fragment>
      {component !== 'list' ? (
        <div className='agents-button-back'>
          <i onClick={() => { setComponent('list') }} className='ico-nazad ico' />
          <span>Nazad na agente</span>
        </div>
      ) : null}

      {component === 'list'
        ? <List setAgent={agent => { setCurrentAgent(agent); setComponent('updateForm') }} />
        : null
      }
      {component === 'addForm' ? <AddAgentForm goToList={() => { setComponent('list') }} /> : null}
      {component === 'updateForm'
        ? (
          <UpdateAgentForm goToList={() => { setCurrentAgent(null); setComponent('list') }} agent={currentAgent} />
        ) : null
      }

      {component === 'list'
        ? (
          <button
            className='btn-oglas-submit'
            style={{ marginTop: 'auto' }}
            onClick={() => { setComponent('addForm') }}
            // onClick={() => { setComponent('addForm') }}
          >
            Dodaj agenta
          </button>
        ) : null
      }
    </React.Fragment>
  )
}

Container.displayName = 'AgentsContainer'
